export class QueryKeys {
  public static currentUser: string = 'currentUserInfo';
  public static healthcareFacility: string = 'healthcareFacility';
  public static clinicBranding: string = 'clinicBranding';
  public static facilityInvitationMessages: string = 'facilityInvitationMessages';
  public static facilityInvitationPdfs: string = 'facilityInvitationPdfs';
  public static facilityRegistrationFields: string = 'facilityRegistrationFields';
  public static healthcareProfessional: string = 'healthcareProfessional';
  public static healthcareProfessionalNew: string = 'healthcareProfessionalNew';
  public static healthcareProfessionals: string = 'healthcareProfessionals';
  public static patient: string = 'patient';
  public static patientInvitations: string = 'patientInvitations';
  public static patientProfiles: string = 'patientProfiles';
  public static login: string = 'login';
  public static legalRequirements: string = 'legalRequirements';
  public static patientToken: string = 'patientToken';
  public static questionnaire: string = 'questionnaire';
  public static questionnaires: string = 'questionnaires';
  public static tasks: string = 'tasks';
  public static newTask: string = 'newTask';
  public static collaboratorNew: string = 'collaboratorNew';
  public static collaborator: string = 'collaborator';
  public static collaborators: string = 'collaborators';
  public static documents: string = 'documents';
  public static document: string = 'document';
  public static testkitorder: string = 'testkitorder';
  public static testKitOrderResume: string = 'testKitOrderResume';
  public static testKits: string = 'testKits';
  public static initialProfiles: string = 'initialProfiles';
  public static taskSummaries: string = 'taskSummaries';
  public static questionnaireAnswer: string = 'questionnaireAnswer';
  public static questionnaireScores: string = 'questionnaireScores';
  public static simulation: string = 'simulation';
  public static drugFormulation: string = 'drugFormulation';
  public static drug: string = 'drug';
  public static lifeEvent: string = 'lifeEvent';
  public static lifeEvents: string = 'lifeEvents';
  public static prescription: string = 'prescription';
  public static prescriptionActivity: string = 'prescriptionActivity';
  public static clinicalNotes: string = 'clinicalNotes';
  public static clinicalNoteActivity: string = 'clinicalNoteActivity';
  public static labTests: string = 'labtests';
  public static pendingLabTests: string = 'pendingLabTests';
  public static defaultSimulation: string = 'defaultSimulation';
  public static simulationCurveGraph: string = 'simulationCurveGraph';
  public static healthcareFacilities: string = 'healthcareFacilities';
  public static medicalNote: string = 'medicalNote';
  public static patientProfileSummary: string = 'patientProfileSummary';
  public static fileNumber: string = 'fileNumber';
  public static physiologicalData: string = 'physiologicalData';
  public static physiologicalDataDetails: string = 'physiologicalDataDetails';
  public static physiologicalUnits: string = 'physiologicalUnits';
  public static physiologicalTypes: string = 'physiologicalTypes';
  public static healthcareFacilityNew: string = 'healthcareFacilityNew';
  public static testkitorderNew: string = 'testkitorderNew';
  public static emailProblems: string = 'emailProblems';
  public static subscription: string = 'subscription';
  public static therapeuticIndication: string = 'therapeuticIndication';
  public static sexes: string = 'sexes';
  public static labTestUnits: string = 'labTestUnits';
  public static billingReport: string = 'billingReport';
  public static markBilled: string = 'markBilled';
  public static biomarkers: string = 'biomarkers';
  public static clinicSubscription: string = 'clinicSubscription';
  public static clinicSeatUsage: string = 'clinicSeatUsage';
  public static termsVersion: string = 'termsVersion';
  public static mmeDrugRouteCombinations: string = 'mmeDrugRouteCombinations';
  public static mmeSavedCalculations: string = 'mmeSavedCalculations';
  public static fentanylDoseOptions: string = 'fentanylDoseOptions';
  public static userPreferences: string = 'userPreferences';
  public static otp: string = 'otp';
  public static otpByPatient: string = 'otpByPatient';
  public static otpCoMedications: string = 'otpCoMedications';
  public static alerts: string = 'alerts';
  public static alertDetail: string = 'alertDetail';
  public static alertSummary: string = 'alertSummary';
  public static patientAlerts: string = 'patientAlerts';
  public static alertRules: string = 'alertRules';
  public static alertRuleConfigurations: string = 'alertRuleConfigurations';
  public static questionnaireAlertConfigurations: string =
    'questionnaireAlertConfigurations';
  public static journalAlertConfiguration: string = 'journalAlertConfiguration';
  public static journalAlertConfigurations: string =
    'journalAlertConfigurations';
  public static clinicPatients: string = 'clinicPatients';
  public static visibleFeatures: string = 'visibleFeatures';
  public static allFeatures: string = 'allFeatures';
  public static roleFeatureConfig: string = 'roleFeatureConfig';
  public static eicfTemplates: string = 'eicfTemplates';
  public static eicfTemplate: string = 'eicfTemplate';
  public static eicfFacilityActiveTemplate: string =
    'eicfFacilityActiveTemplate';
  public static eicfActiveConsent: string = 'eicfActiveConsent';
  public static eicfMySignedConsent: string = 'eicfMySignedConsent';
  public static eicfPendingPhysicianConsents: string =
    'eicfPendingPhysicianConsents';
  public static eicfSignedPhysicianConsents: string =
    'eicfSignedPhysicianConsents';
  public static eicfEscalationConfig: string = 'eicfEscalationConfig';
  public static carePlanTemplates: string = 'carePlanTemplates';
  public static patientProgram: string = 'patientProgram';
}
